<div class="line-items-picker">

  <div class="picker-head">
    <h3 class="picker-title">Materials &amp; Services</h3>
    <button type="button" class="picker-close" aria-label="Close" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  @if (!hasAnyItems) {
    <div class="picker-empty">
      <mat-icon class="picker-empty-icon">inventory_2</mat-icon>
      <p class="picker-empty-title">No materials or services on this ticket yet.</p>
      <p class="picker-empty-hint">Add them from the Materials &amp; Services tab, then link them to checklist items here.</p>
    </div>
  } @else {
    <div class="picker-tabs" role="tablist">
      <button type="button" class="picker-tab" role="tab"
              [class.picker-tab--active]="activeTab === 'material'"
              [attr.aria-selected]="activeTab === 'material'"
              (click)="setTab('material')">
        <mat-icon>inventory_2</mat-icon>
        <span>Materials</span>
        <span class="tab-count">{{ countFor('material') }}</span>
      </button>

      <button type="button" class="picker-tab" role="tab"
              [class.picker-tab--active]="activeTab === 'service'"
              [attr.aria-selected]="activeTab === 'service'"
              (click)="setTab('service')">
        <mat-icon>handyman</mat-icon>
        <span>Services</span>
        <span class="tab-count">{{ countFor('service') }}</span>
      </button>
    </div>

    <div class="picker-body">
      <div class="search-box">
        <mat-icon class="search-icon">search</mat-icon>
        <input type="text" class="search-input" placeholder="Search line items…"
               [(ngModel)]="search" [ngModelOptions]="{ standalone: true }"
               aria-label="Search line items">
      </div>

      @if (visibleItems.length === 0) {
        <p class="picker-status">
          @if (search.trim()) {
            No {{ activeTab === 'material' ? 'materials' : 'services' }} match your search.
          } @else {
            No {{ activeTab === 'material' ? 'materials' : 'services' }} on this ticket.
          }
        </p>
      } @else {
        <div class="picker-list">
          @for (item of visibleItems; track item.id ?? item.job_scope_item_id) {
            <div class="picker-row" [class.picker-row--selected]="isSelected(item)" (click)="toggle(item)">
              <mat-checkbox class="bidone-checkbox" [checked]="isSelected(item)"
                            (click)="$event.stopPropagation()" (change)="toggle(item)"
                            [attr.aria-label]="(isSelected(item) ? 'Unlink ' : 'Link ') + item.item_name">
              </mat-checkbox>

              <div class="picker-row-main">
                <p class="picker-row-title" [matTooltip]="item.description || ''">{{ item.item_name || '—' }}</p>
                <p class="picker-row-meta">
                  <mat-icon class="meta-icon">store</mat-icon>
                  <span class="meta-vendor">{{ item.vendor_name || '—' }}</span>
                  @if (item.linked_scope_name) {
                    <span class="meta-dot">·</span>
                    <span class="meta-vendor">{{ item.linked_scope_name }}</span>
                  }
                </p>
              </div>

              <div class="picker-row-right">
                <span class="picker-row-qty">Qty {{ item.quantity ?? '—' }}</span>
                @if (item.price !== null && item.price !== undefined) {
                  <span class="picker-row-price">{{ item.price | currency }}</span>
                }
              </div>
            </div>
          }
        </div>
      }
    </div>

    @if (selected.size) {
      <div class="picker-selected">
        <span class="picker-selected-label">Linked</span>
        <div class="picker-selected-chips">
          @for (item of selectedList; track item.id ?? item.job_scope_item_id) {
            <span class="selected-chip">
              <mat-icon class="selected-chip-icon">{{ kindIcon(item) }}</mat-icon>
              <span class="selected-chip-name">{{ item.item_name }}</span>
              <button type="button" class="selected-chip-remove" [attr.aria-label]="'Unlink ' + item.item_name"
                      (click)="toggle(item)">
                <mat-icon>close</mat-icon>
              </button>
            </span>
          }
        </div>
      </div>
    }
  }

  <div class="picker-foot">
    <span class="selected-count">
      @if (hasAnyItems) {
        {{ selectedCountFor('material') }} material{{ selectedCountFor('material') === 1 ? '' : 's' }},
        {{ selectedCountFor('service') }} service{{ selectedCountFor('service') === 1 ? '' : 's' }} linked
      }
    </span>
    <div class="picker-actions">
      <button type="button" class="picker-btn-cancel" (click)="close()">Cancel</button>
      @if (hasAnyItems) {
        <button type="button" class="picker-btn-save" [disabled]="!hasChanges" (click)="save()">Save</button>
      }
    </div>
  </div>
</div>
